import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ym from 'react-yandex-metrika';
import { PixelServices } from 'services/pixelServices';

export const AnalyticalPage = () => {
  const location = useLocation();
  useEffect(() => {
    ym('hit', location.pathname);
    PixelServices.axonTrack('page_view');
  }, [location]);
  return null;
};
